<template>
  <div class="blog-admin">
    <div class="header">
      Administración del blog
      <div class="button" @click="$router.push('/admin/editor')">Nuevo <img src="/right-arrow.svg" alt="Logo flagship"></div>
    </div>
    <div class="posts">
      <div class="post" v-for="post in posts" :key="post.id">
        <div class="post-image" :style="{ backgroundImage: `url(${post.imageUrl})` }">
        </div>
        <div class="post-title">
          {{ post.title }}
        </div>
        <div class="post-summary">
          {{ post.summary }}
        </div>
        <div class="post-actions">
          <div style="color: #91DC5A" class="action" @click="$router.push(`/blog/${post.id}`)">
            <img src="/icons/eye.svg" class="svg-icon">
            Ver
          </div>
          <div style="color: #006DF0" class="action" @click="$router.push(`/admin/editor?post=${post.id}`)">
            <img src="/icons/writing.svg" class="svg-icon">
            Editar
          </div>
          <div style="color: #D80027" class="action" @click="deletePost(post.id)">
            <img src="/icons/trash.svg" class="svg-icon">
            Eliminar
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('blog');
export default {
  computed: {
    ...mapState([
      'posts',
    ]),
  },
  methods: {
    ...mapActions([
      'getPosts',
      'deletePost',
    ]),
  },
  mounted() {
    this.getPosts();
  },
};
</script>

<style scoped lang="scss">
.blog-admin {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.header {
  font-weight: bolder;
  font-size: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.posts {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.post {
  border: 1px solid #e8e8e8;
  background-color: white;
  padding: 20px;
  border-radius: 6px;
  margin-top: 24px;
  width: 48%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.post-image {
  width: 100%;
  height: 150px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 2px;
  margin-bottom: 16px;
}
.date {
  background-color: white;
  font-size: 16px;
  margin-bottom: 20px;
  color: #2c70c1;
}
.post-title {
  font-size: 28px;
  font-weight: bold;
  color: black;
  width: 100%;
  height: 100px;
}
.post-summary {
  background-color: white;
  font-size: 16px;
  line-height: 1.5;
  height: 80px;
}
.post-actions {
  width: 100%;
  display: flex;
  margin-top: 30px;
}
.action {
  width: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  flex-direction: column;
  cursor: pointer;
}
.svg-icon {
  width: 20px;
  margin-bottom: 8px;
}
.button {
  font-family: 'Roboto Condensed', sans-serif;
  background-color: #2c70c1;;
  color: white;
  width: 150px;
  display: flex;
  font-weight: bolder;
  font-size: 15px;
  text-transform: uppercase;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0 5px 20px;
  img {
    height: 24px;
    width: auto;
    margin-right: 20px;
  }
}
@media only screen and (max-width: 740px) {
  .post {
    width: 95%;
  }
  .posts {
    justify-content: center;
  }
}
</style>

